module.exports = __webpack_public_path__ + "img/shared-by-you.52993082.svg";